"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9926],{

/***/ 15953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ CruiseDepartureDatePickerBlock; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/index.ts + 2 modules
var FullScreenModalDialog = __webpack_require__(19484);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/DatePicker/index.ts + 2 modules
var DatePicker = __webpack_require__(31264);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/DatePicker/HorizontalDatePicker.tsx + 1 modules
var HorizontalDatePicker = __webpack_require__(16201);
// EXTERNAL MODULE: ./main/javascripts/utils/DateUtil.ts
var DateUtil = __webpack_require__(16341);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./main/javascripts/components/form/Label.tsx
var Label = __webpack_require__(35183);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./main/javascripts/components/form/CalendarDateBlock.tsx
var CalendarDateBlock = __webpack_require__(33935);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/form/MinDepartureDateInput.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // import { IColorStyle } from "main/javascripts/components/form/Label";



var MinDepartureDateInput = function MinDepartureDateInput(props) {
  var namespace = props.namespace,
      name = props.name,
      isActive = props.isActive,
      onClick = props.onClick,
      borderColorStyleKey = props.borderColorStyleKey,
      fontSizeStyleKey = props.fontSizeStyleKey,
      inputBlockRef = props.inputBlockRef;
  var fieldName = name || "min_departure_date";

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    // label: {
    //   namespace: namespace,
    //   label: "minDepartureDate",
    //   colorStyleKey: labelColorStyleKey,
    // },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,index_esm/* get */.U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey,
    fontSizeStyleKey: fontSizeStyleKey
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CalendarDateBlock/* CalendarDateBlock */.A, _objectSpread({}, attrs));
};
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/form/MaxDepartureDateInput.tsx


function MaxDepartureDateInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MaxDepartureDateInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MaxDepartureDateInput_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MaxDepartureDateInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // import { IColorStyle } from "main/javascripts/components/form/Label";



var MaxDepartureDateInput = function MaxDepartureDateInput(props) {
  var namespace = props.namespace,
      name = props.name,
      isActive = props.isActive,
      onClick = props.onClick,
      borderColorStyleKey = props.borderColorStyleKey,
      fontSizeStyleKey = props.fontSizeStyleKey,
      inputBlockRef = props.inputBlockRef;
  var fieldName = name || "max_departure_date";

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    // label: {
    //   namespace: namespace,
    //   label: "maxDepartureDate",
    //   colorStyleKey: labelColorStyleKey,
    // },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,index_esm/* get */.U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey,
    fontSizeStyleKey: fontSizeStyleKey
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CalendarDateBlock/* CalendarDateBlock */.A, MaxDepartureDateInput_objectSpread({}, attrs));
};
// EXTERNAL MODULE: ./main/javascripts/constants/DateTypes.ts
var DateTypes = __webpack_require__(71797);
// EXTERNAL MODULE: ./main/javascripts/constants/CruiseConstants.ts
var CruiseConstants = __webpack_require__(78022);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseDepartureDatePickerBlock.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
























var CruiseDepartureDatePickerBlock = function CruiseDepartureDatePickerBlock(props) {
  var _props$labelColorStyl = props.labelColorStyleKey,
      labelColorStyleKey = _props$labelColorStyl === void 0 ? "default" : _props$labelColorStyl,
      borderColorStyleKey = props.borderColorStyleKey,
      fontSizeStyleKey = props.fontSizeStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling,
      onChange = props.onChange;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t; // TODO: 旧reducerをそのまま使用


  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      trigger = _useFormContext.trigger;

  var _useWatch = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: ["min_departure_date", "max_departure_date"]
  }),
      _useWatch2 = (0,slicedToArray/* default */.Z)(_useWatch, 2),
      minDepartureDateValue = _useWatch2[0],
      maxDepartureDateValue = _useWatch2[1];

  var _useState = (0,react.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var _useState2 = (0,react.useState)(null),
      pickerDateType = _useState2[0],
      setPickerDateType = _useState2[1];

  var inputMinDepartureDateRef = (0,react.useRef)();
  var inputMaxDepartureDateRef = (0,react.useRef)();

  var onClickMinDepartureDate = function onClickMinDepartureDate() {
    setDisplayedPicker(true);
    setPickerDateType(DateTypes/* DateTypes.fromDate */.t.fromDate);
  };

  var onClickMaxDepartureDate = function onClickMaxDepartureDate() {
    setDisplayedPicker(true);
    setPickerDateType(DateTypes/* DateTypes.toDate */.t.toDate);
  };

  var onComplete = function onComplete(startDate, endDate) {
    var minDepartureDateString = "";
    var maxDepartureDateString = "";

    if (startDate) {
      minDepartureDateString = (0,format["default"])(startDate, "yyyy/LL/dd");
      setValue("min_departure_date", minDepartureDateString);
      void trigger(["min_departure_date"]);
    }

    if (endDate) {
      maxDepartureDateString = (0,format["default"])(endDate, "yyyy/LL/dd");
      setValue("max_departure_date", maxDepartureDateString);
      void trigger(["max_departure_date"]);
    }

    if (onChange) {
      onChange(minDepartureDateString, maxDepartureDateString);
    }

    hidePicker();
  };

  var onUpdate = function onUpdate(startDate, endDate, isEndStep) {
    var minDepartureDateString = "";
    var maxDepartureDateString = "";

    if (startDate) {
      minDepartureDateString = (0,format["default"])(startDate, "yyyy/LL/dd");
      setValue("min_departure_date", minDepartureDateString);
      void trigger(["min_departure_date"]);
    }

    if (endDate) {
      maxDepartureDateString = (0,format["default"])(endDate, "yyyy/LL/dd");
      setValue("max_departure_date", maxDepartureDateString);
      void trigger(["max_departure_date"]);
    }

    if (!isEndStep) {
      setPickerDateType(DateTypes/* DateTypes.toDate */.t.toDate);
    }

    if (onChange) {
      onChange(minDepartureDateString, maxDepartureDateString);
    }
  };

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
    setPickerDateType(null);
  };

  var fromDate = minDepartureDateValue ? (0,DateUtil/* parseDate */.s)(minDepartureDateValue) : null;
  var toDate = maxDepartureDateValue ? (0,DateUtil/* parseDate */.s)(maxDepartureDateValue) : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: labelBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label/* Label */._, {
        namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
        label: "departureDate",
        colorStyleKey: labelColorStyleKey
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: inputBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MinDepartureDateInput, {
        namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
        isActive: pickerDateType === DateTypes/* DateTypes.fromDate */.t.fromDate,
        onClick: onClickMinDepartureDate,
        inputBlockRef: inputMinDepartureDateRef // labelColorStyleKey={labelColorStyleKey}
        ,
        borderColorStyleKey: borderColorStyleKey,
        fontSizeStyleKey: fontSizeStyleKey
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: delimiterStyle,
        children: "\u2014"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaxDepartureDateInput, {
        namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
        isActive: pickerDateType === DateTypes/* DateTypes.toDate */.t.toDate,
        onClick: onClickMaxDepartureDate,
        inputBlockRef: inputMaxDepartureDateRef // labelColorStyleKey={labelColorStyleKey}
        ,
        borderColorStyleKey: borderColorStyleKey,
        fontSizeStyleKey: fontSizeStyleKey
      })]
    }), (0,responsiveStyle/* isPhone */.Mn)(breakpoint) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
      displayed: displayedPicker,
      closeHandler: hidePicker,
      colorMode: "light",
      disableStopBodyScrolling: disableStopBodyScrolling,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePicker/* ScrollableDatePicker */.d, {
        fromDate: fromDate,
        toDate: toDate,
        onComplete: onComplete,
        numberOfMonths: 12,
        maxDays: CruiseConstants/* MAX_CRUISE_DEPARTURE_DATE_RANGE_DAYS */.DP,
        outOfRangeMessage: t("search.calendarMaxDaysMessage"),
        startDateLabel: t("label:common.departureDate"),
        endDateLabel: t("label:common.departureDate"),
        dateType: pickerDateType
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalDatePicker/* HorizontalDatePicker */.R, {
      fromDate: fromDate,
      toDate: toDate,
      onUpdate: onUpdate,
      hidePicker: hidePicker,
      numberOfMonths: 12,
      maxDays: CruiseConstants/* MAX_CRUISE_DEPARTURE_DATE_RANGE_DAYS */.DP,
      outOfRangeMessage: t("search.calendarMaxDaysMessage"),
      startDateLabel: t("label:common.departureDate"),
      endDateLabel: t("label:common.departureDate"),
      displayedPicker: displayedPicker,
      dateType: pickerDateType,
      fromInputRef: inputMinDepartureDateRef.current,
      toInputRef: inputMaxDepartureDateRef.current,
      alignmentStyleKey: "left"
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;flex:1;padding:", spaceStyle/* space.atom */.D.atom, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var inputBlockStyle =  true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0;
var labelBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:calc(", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.body1 */.Nv.body1, " - ", typographyStyle/* fontSize.body */.JB.body, ") / 2) ", spaceStyle/* space.atom */.D.atom, " 0;margin-bottom:calc(\n    (", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.body1 */.Nv.body1, " - ", typographyStyle/* fontSize.body */.JB.body, ") / 2) * -1\n  );" + ( true ? "" : 0),  true ? "" : 0);
var delimiterStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;align-items:center;height:40px;padding:calc(", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.body1 */.Nv.body1, " - ", typographyStyle/* fontSize.body */.JB.body, ") / 2) 0 0;color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding-left:", spaceStyle/* space.atom */.D.atom, ";padding-right:", spaceStyle/* space.atom */.D.atom, ";}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 14608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ CruiseDestinationBlock; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/components/form/InputAutosuggestBlock.tsx
var InputAutosuggestBlock = __webpack_require__(1399);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 1 modules
var store = __webpack_require__(79169);
// EXTERNAL MODULE: ./main/javascripts/features/cruise/cruiseSuggestionSlice.ts
var cruiseSuggestionSlice = __webpack_require__(60205);
// EXTERNAL MODULE: ./main/javascripts/components/form/InputHidden.tsx
var InputHidden = __webpack_require__(81047);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/components/suggestionPicker/SuggestionPicker.tsx + 2 modules
var SuggestionPicker = __webpack_require__(50193);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/index.ts + 2 modules
var FullScreenModalDialog = __webpack_require__(19484);
// EXTERNAL MODULE: ./main/javascripts/components/suggestionPicker/SuggestionFieldButton.tsx
var SuggestionFieldButton = __webpack_require__(83827);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
// EXTERNAL MODULE: ./main/javascripts/utils/googleTagManagerUtil.ts
var googleTagManagerUtil = __webpack_require__(49224);
// EXTERNAL MODULE: ./main/javascripts/constants/GoogleTagManagerEventTypes.ts
var GoogleTagManagerEventTypes = __webpack_require__(12327);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseDestinationInputBlock.tsx





















var CruiseDestinationInputBlock = function CruiseDestinationInputBlock(props) {
  var fetchCruiseDestinationSuggestions = props.fetchCruiseDestinationSuggestions,
      defaultDestinations = props.defaultDestinations,
      suggestOptions = props.suggestOptions,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      fontSizeStyleKey = props.fontSizeStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t;

  var destinations = (0,store/* useAppSelector */.CG)(cruiseSuggestionSlice/* cruiseDestinationSuggestionsSelector */.Mw);
  var isLoading = (0,store/* useAppSelector */.CG)(cruiseSuggestionSlice/* loadingSelector */.E2); // TODO: 旧reducerをそのまま使用

  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var fieldName = "origin_destination_region";
  var namesFieldName = "origin_destination_region_names";
  var idsFieldName = "origin_destination_region_ids";
  var value = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: fieldName
  }) || "";
  var nameValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: namesFieldName
  }) || [];
  var idValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: idsFieldName
  }) || [];

  var _useState = (0,react.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var inputTimeoutRef = (0,react.useRef)(null);
  var valueRef = (0,react.useRef)(value);
  valueRef.current = value;
  var currentValue = (0,responsiveStyle/* isPhone */.Mn)(breakpoint) ? value : value;

  var validDefaultDestinations = function validDefaultDestinations() {
    var _values$find;

    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    return (_values$find = values.find(function (value) {
      return value !== undefined && value.length > 0;
    })) !== null && _values$find !== void 0 ? _values$find : [];
  };

  var suggestions = currentValue ? destinations : validDefaultDestinations(defaultDestinations);
  (0,react.useEffect)(function () {
    return function () {
      clearTimeout(inputTimeoutRef.current);
    };
  }, []);

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var onPickerButtonClick = function onPickerButtonClick() {
    setDisplayedPicker(true);
  };

  var onSelected = function onSelected(suggestion) {
    setValue(fieldName, "");
    setValue(namesFieldName, [].concat((0,toConsumableArray/* default */.Z)(nameValues), [suggestion.name]));
    setValue(idsFieldName, [].concat((0,toConsumableArray/* default */.Z)(idValues), [suggestion.id]));
    (0,googleTagManagerUtil/* event */.B)(GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.destination */.T.destination, {
      destination_id: suggestion.id,
      destination_type: suggestion.destinationType,
      destination: suggestion.longName
    });

    if (displayedPicker) {
      hidePicker();
    }
  };

  var onClearInput = function onClearInput() {
    clearTimeout(inputTimeoutRef.current);
    setValue(fieldName, "");
  };

  var error = (0,index_esm/* get */.U2)(errors, namesFieldName) || (0,index_esm/* get */.U2)(errors, idsFieldName);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputHidden/* InputHidden */.R, {
      name: idsFieldName
    }), (0,responsiveStyle/* isPhone */.Mn)(breakpoint) ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionFieldButton/* SuggestionFieldButton */.M, {
        namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
        name: fieldName,
        label: {
          namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
          label: t("label:common.destination"),
          colorStyleKey: labelColorStyleKey
        },
        longName: value,
        placeholder: t("form.placeholders.cruise.destinationPlaceholder"),
        onClick: onPickerButtonClick,
        borderColorStyleKey: borderColorStyleKey,
        fontSizeStyleKey: fontSizeStyleKey,
        error: error
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
        displayed: displayedPicker,
        closeHandler: hidePicker,
        colorMode: "light",
        disableStopBodyScrolling: disableStopBodyScrolling,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: headerTitleStyle,
          children: t("cruise.destination")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionPicker/* SuggestionPicker */.W, {
          name: fieldName,
          suggestions: suggestions,
          placeholder: t("form.placeholders.cruise.destinationPlaceholder"),
          isLoading: isLoading,
          suggestOptions: suggestOptions,
          onRequest: fetchCruiseDestinationSuggestions,
          onSelected: onSelected,
          onClear: onClearInput
        })]
      })]
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputAutosuggestBlock/* InputAutosuggestBlock */.A, {
      namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
      label: {
        namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
        label: t("label:common.destination"),
        colorStyleKey: labelColorStyleKey
      },
      input: {
        name: fieldName,
        value: value,
        type: "text",
        placeholder: t("form.placeholders.cruise.destinationPlaceholder")
      },
      error: error,
      onSelected: onSelected,
      fetchDestinationSuggest: fetchCruiseDestinationSuggestions,
      suggestOptions: suggestOptions,
      suggestions: suggestions,
      onClear: onClearInput,
      disableOnFocusRequest: true,
      alwaysShowSuggestions: true,
      borderColorStyleKey: borderColorStyleKey,
      fontSizeStyleKey: fontSizeStyleKey
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)( true ? "" : 0,  true ? "" : 0);
var headerTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:0;left:50%;line-height:3rem;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";font-weight:bold;letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";transform:translateX(-50%);" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/form/multipleSelect/MultipleSelectTag.tsx
var MultipleSelectTag = __webpack_require__(77498);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseDestinationBlock.tsx


var _excluded = ["text"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var CruiseDestinationBlock = function CruiseDestinationBlock(props) {
  var defaultDestinations = props.defaultDestinations,
      suggestOptions = props.suggestOptions,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      fontSizeStyleKey = props.fontSizeStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;
  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control;

  var namesFieldName = "origin_destination_region_names";
  var idsFieldName = "origin_destination_region_ids";
  var idValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: idsFieldName
  }) || [];
  var nameValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: namesFieldName
  }) || [];

  var onRemoveClick = function onRemoveClick(value) {
    var targetIndex = idValues.findIndex(function (id) {
      return id === value;
    });

    if (targetIndex >= 0) {
      var newIds = idValues.filter(function (_, index) {
        return index !== targetIndex;
      });
      var newNames = nameValues.filter(function (_, index) {
        return index !== targetIndex;
      });
      setValue(idsFieldName, newIds);
      setValue(namesFieldName, newNames);
    }
  };

  var fetchCruiseDestinationSuggestionsAction = function fetchCruiseDestinationSuggestionsAction(data) {
    var text = data.text,
        rest = (0,objectWithoutProperties/* default */.Z)(data, _excluded);

    appDispatch((0,cruiseSuggestionSlice/* debouncedFetchCruiseDestinationSuggestions */.o0)({
      params: _objectSpread({
        text: text
      }, rest)
    }));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: CruiseDestinationBlock_blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseDestinationInputBlock, {
      fetchCruiseDestinationSuggestions: fetchCruiseDestinationSuggestionsAction,
      labelColorStyleKey: labelColorStyleKey,
      suggestOptions: suggestOptions,
      defaultDestinations: defaultDestinations,
      borderColorStyleKey: borderColorStyleKey,
      fontSizeStyleKey: fontSizeStyleKey,
      disableStopBodyScrolling: disableStopBodyScrolling
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: selectTagBlockStyle,
      children: idValues.map(function (id, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultipleSelectTag/* MultipleSelectTag */.N, {
          text: nameValues[index],
          value: id,
          onRemoveClick: onRemoveClick
        }, id);
      })
    })]
  });
};
var CruiseDestinationBlock_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 0;flex:1;" + ( true ? "" : 0),  true ? "" : 0);
var selectTagBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-wrap:wrap;gap:", spaceStyle/* space.atom */.D.atom, ";padding:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 76308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ CruiseOriginBlock; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/components/form/InputAutosuggestBlock.tsx
var InputAutosuggestBlock = __webpack_require__(1399);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 1 modules
var store = __webpack_require__(79169);
// EXTERNAL MODULE: ./main/javascripts/features/cruise/cruiseSuggestionSlice.ts
var cruiseSuggestionSlice = __webpack_require__(60205);
// EXTERNAL MODULE: ./main/javascripts/components/form/InputHidden.tsx
var InputHidden = __webpack_require__(81047);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/components/suggestionPicker/SuggestionPicker.tsx + 2 modules
var SuggestionPicker = __webpack_require__(50193);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/index.ts + 2 modules
var FullScreenModalDialog = __webpack_require__(19484);
// EXTERNAL MODULE: ./main/javascripts/components/suggestionPicker/SuggestionFieldButton.tsx
var SuggestionFieldButton = __webpack_require__(83827);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
// EXTERNAL MODULE: ./main/javascripts/utils/googleTagManagerUtil.ts
var googleTagManagerUtil = __webpack_require__(49224);
// EXTERNAL MODULE: ./main/javascripts/constants/GoogleTagManagerEventTypes.ts
var GoogleTagManagerEventTypes = __webpack_require__(12327);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseOriginInputBlock.tsx





















var CruiseOriginInputBlock = function CruiseOriginInputBlock(props) {
  var fetchCruiseOriginSuggestions = props.fetchCruiseOriginSuggestions,
      defaultOrigins = props.defaultOrigins,
      suggestOptions = props.suggestOptions,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      fontSizeStyleKey = props.fontSizeStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t;

  var destinations = (0,store/* useAppSelector */.CG)(cruiseSuggestionSlice/* cruiseOriginSuggestionsSelector */.Uh);
  var isLoading = (0,store/* useAppSelector */.CG)(cruiseSuggestionSlice/* loadingSelector */.E2); // TODO: 旧reducerをそのまま使用

  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var fieldName = "origin_region";
  var namesFieldName = "origin_region_names";
  var idsFieldName = "origin_region_ids";
  var value = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: fieldName
  }) || "";
  var nameValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: namesFieldName
  }) || [];
  var idValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: idsFieldName
  }) || [];

  var _useState = (0,react.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var inputTimeoutRef = (0,react.useRef)(null);
  var valueRef = (0,react.useRef)(value);
  valueRef.current = value;
  var currentValue = (0,responsiveStyle/* isPhone */.Mn)(breakpoint) ? value : value;

  var validDefaultOrigins = function validDefaultOrigins() {
    var _values$find;

    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    return (_values$find = values.find(function (value) {
      return value !== undefined && value.length > 0;
    })) !== null && _values$find !== void 0 ? _values$find : [];
  };

  var suggestions = currentValue ? destinations : validDefaultOrigins(defaultOrigins);
  (0,react.useEffect)(function () {
    return function () {
      clearTimeout(inputTimeoutRef.current);
    };
  }, []);

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var onPickerButtonClick = function onPickerButtonClick() {
    setDisplayedPicker(true);
  };

  var onSelected = function onSelected(suggestion) {
    setValue(fieldName, "");
    setValue(namesFieldName, [].concat((0,toConsumableArray/* default */.Z)(nameValues), [suggestion.name]));
    setValue(idsFieldName, [].concat((0,toConsumableArray/* default */.Z)(idValues), [suggestion.id]));
    (0,googleTagManagerUtil/* event */.B)(GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.origin */.T.origin, {
      destination_id: suggestion.id,
      destination_type: suggestion.destinationType,
      destination: suggestion.longName
    });

    if (displayedPicker) {
      hidePicker();
    }
  };

  var onClearInput = function onClearInput() {
    clearTimeout(inputTimeoutRef.current);
    setValue(fieldName, "");
  };

  var error = (0,index_esm/* get */.U2)(errors, namesFieldName) || (0,index_esm/* get */.U2)(errors, idsFieldName);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputHidden/* InputHidden */.R, {
      name: idsFieldName
    }), (0,responsiveStyle/* isPhone */.Mn)(breakpoint) ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionFieldButton/* SuggestionFieldButton */.M, {
        namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
        name: fieldName,
        label: {
          namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
          label: t("label:common.origin"),
          colorStyleKey: labelColorStyleKey
        },
        longName: value,
        placeholder: t("form.placeholders.cruise.originPlaceholder"),
        onClick: onPickerButtonClick,
        borderColorStyleKey: borderColorStyleKey,
        fontSizeStyleKey: fontSizeStyleKey,
        error: error
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
        displayed: displayedPicker,
        closeHandler: hidePicker,
        colorMode: "light",
        disableStopBodyScrolling: disableStopBodyScrolling,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: headerTitleStyle,
          children: t("cruise.origin")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionPicker/* SuggestionPicker */.W, {
          name: fieldName,
          suggestions: suggestions,
          placeholder: t("form.placeholders.cruise.originPlaceholder"),
          isLoading: isLoading,
          suggestOptions: suggestOptions,
          onRequest: fetchCruiseOriginSuggestions,
          onSelected: onSelected,
          onClear: onClearInput
        })]
      })]
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputAutosuggestBlock/* InputAutosuggestBlock */.A, {
      namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
      label: {
        namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
        label: t("label:common.origin"),
        colorStyleKey: labelColorStyleKey
      },
      input: {
        name: fieldName,
        value: value,
        type: "text",
        placeholder: t("form.placeholders.cruise.originPlaceholder")
      },
      error: error,
      onSelected: onSelected,
      fetchDestinationSuggest: fetchCruiseOriginSuggestions,
      suggestOptions: suggestOptions,
      suggestions: suggestions,
      onClear: onClearInput,
      disableOnFocusRequest: true,
      alwaysShowSuggestions: true,
      borderColorStyleKey: borderColorStyleKey,
      fontSizeStyleKey: fontSizeStyleKey
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)( true ? "" : 0,  true ? "" : 0);
var headerTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:0;left:50%;line-height:3rem;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";font-weight:bold;letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";transform:translateX(-50%);" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/form/multipleSelect/MultipleSelectTag.tsx
var MultipleSelectTag = __webpack_require__(77498);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseOriginBlock.tsx


var _excluded = ["text"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var CruiseOriginBlock = function CruiseOriginBlock(props) {
  var defaultOrigins = props.defaultOrigins,
      suggestOptions = props.suggestOptions,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      fontSizeStyleKey = props.fontSizeStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;
  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control;

  var namesFieldName = "origin_region_names";
  var idsFieldName = "origin_region_ids";
  var idValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: idsFieldName
  }) || [];
  var nameValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: namesFieldName
  }) || [];

  var onRemoveClick = function onRemoveClick(value) {
    var targetIndex = idValues.findIndex(function (id) {
      return id === value;
    });

    if (targetIndex >= 0) {
      var newIds = idValues.filter(function (_, index) {
        return index !== targetIndex;
      });
      var newNames = nameValues.filter(function (_, index) {
        return index !== targetIndex;
      });
      setValue(idsFieldName, newIds);
      setValue(namesFieldName, newNames);
    }
  };

  var fetchCruiseOriginSuggestionsAction = function fetchCruiseOriginSuggestionsAction(data) {
    var text = data.text,
        rest = (0,objectWithoutProperties/* default */.Z)(data, _excluded);

    appDispatch((0,cruiseSuggestionSlice/* debouncedFetchCruiseOriginSuggestions */.ve)({
      params: _objectSpread({
        text: text
      }, rest)
    }));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: CruiseOriginBlock_blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseOriginInputBlock, {
      fetchCruiseOriginSuggestions: fetchCruiseOriginSuggestionsAction,
      labelColorStyleKey: labelColorStyleKey,
      suggestOptions: suggestOptions,
      defaultOrigins: defaultOrigins,
      borderColorStyleKey: borderColorStyleKey,
      fontSizeStyleKey: fontSizeStyleKey,
      disableStopBodyScrolling: disableStopBodyScrolling
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: selectTagBlockStyle,
      children: idValues.map(function (id, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultipleSelectTag/* MultipleSelectTag */.N, {
          text: nameValues[index],
          value: id,
          onRemoveClick: onRemoveClick
        }, id);
      })
    })]
  });
};
var CruiseOriginBlock_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 0;flex:1;" + ( true ? "" : 0),  true ? "" : 0);
var selectTagBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-wrap:wrap;gap:", spaceStyle/* space.atom */.D.atom, ";padding:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 15400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ VesselBrandBlock; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/components/form/InputAutosuggestBlock.tsx
var InputAutosuggestBlock = __webpack_require__(1399);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 1 modules
var store = __webpack_require__(79169);
// EXTERNAL MODULE: ./main/javascripts/features/cruise/cruiseSuggestionSlice.ts
var cruiseSuggestionSlice = __webpack_require__(60205);
// EXTERNAL MODULE: ./main/javascripts/components/form/InputHidden.tsx
var InputHidden = __webpack_require__(81047);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/components/suggestionPicker/SuggestionPicker.tsx + 2 modules
var SuggestionPicker = __webpack_require__(50193);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/index.ts + 2 modules
var FullScreenModalDialog = __webpack_require__(19484);
// EXTERNAL MODULE: ./main/javascripts/components/suggestionPicker/SuggestionFieldButton.tsx
var SuggestionFieldButton = __webpack_require__(83827);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/VesselBrandInputBlock.tsx



















var VesselBrandInputBlock = function VesselBrandInputBlock(props) {
  var fetchVesselBrandSuggestions = props.fetchVesselBrandSuggestions,
      defaultVesselBrands = props.defaultVesselBrands,
      suggestOptions = props.suggestOptions,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      fontSizeStyleKey = props.fontSizeStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t;

  var vesselBrands = (0,store/* useAppSelector */.CG)(cruiseSuggestionSlice/* vesselBrandSuggestionsSelector */.Od);
  var isLoading = (0,store/* useAppSelector */.CG)(cruiseSuggestionSlice/* loadingSelector */.E2); // TODO: 旧reducerをそのまま使用

  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var fieldName = "vessel_brand";
  var namesFieldName = "vessel_brand_names";
  var idsFieldName = "vessel_brand_id"; // 単数

  var value = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: fieldName
  }) || "";
  var nameValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: namesFieldName
  }) || [];
  var idValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: idsFieldName
  }) || [];

  var _useState = (0,react.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var inputTimeoutRef = (0,react.useRef)(null);
  var valueRef = (0,react.useRef)(value);
  valueRef.current = value;
  var currentValue = (0,responsiveStyle/* isPhone */.Mn)(breakpoint) ? value : value;

  var validDefaultVesselBrands = function validDefaultVesselBrands() {
    var _values$find;

    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    return (_values$find = values.find(function (value) {
      return value !== undefined && value.length > 0;
    })) !== null && _values$find !== void 0 ? _values$find : [];
  };

  var suggestions = currentValue ? vesselBrands : validDefaultVesselBrands(defaultVesselBrands);
  (0,react.useEffect)(function () {
    return function () {
      clearTimeout(inputTimeoutRef.current);
    };
  }, []);

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var onPickerButtonClick = function onPickerButtonClick() {
    setDisplayedPicker(true);
  };

  var onSelected = function onSelected(suggestion) {
    setValue(fieldName, "");
    setValue(namesFieldName, [].concat((0,toConsumableArray/* default */.Z)(nameValues), [suggestion.name]));
    setValue(idsFieldName, [].concat((0,toConsumableArray/* default */.Z)(idValues), [suggestion.id]));

    if (displayedPicker) {
      hidePicker();
    }
  };

  var onClearInput = function onClearInput() {
    clearTimeout(inputTimeoutRef.current);
    setValue(fieldName, "");
  };

  var error = (0,index_esm/* get */.U2)(errors, namesFieldName) || (0,index_esm/* get */.U2)(errors, idsFieldName);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputHidden/* InputHidden */.R, {
      name: idsFieldName
    }), (0,responsiveStyle/* isPhone */.Mn)(breakpoint) ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionFieldButton/* SuggestionFieldButton */.M, {
        namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
        name: fieldName,
        label: {
          namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
          label: t("label:cruise.vesselBrand"),
          colorStyleKey: labelColorStyleKey
        },
        longName: value,
        placeholder: t("form.placeholders.cruise.vesselBrandPlaceholder"),
        onClick: onPickerButtonClick,
        borderColorStyleKey: borderColorStyleKey,
        fontSizeStyleKey: fontSizeStyleKey,
        error: error
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
        displayed: displayedPicker,
        closeHandler: hidePicker,
        colorMode: "light",
        disableStopBodyScrolling: disableStopBodyScrolling,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: headerTitleStyle,
          children: t("cruise.vesselBrand")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionPicker/* SuggestionPicker */.W, {
          name: fieldName,
          suggestions: suggestions,
          placeholder: t("form.placeholders.cruise.vesselBrandPlaceholder"),
          isLoading: isLoading,
          suggestOptions: suggestOptions,
          onRequest: fetchVesselBrandSuggestions,
          onSelected: onSelected,
          onClear: onClearInput,
          suggestIconType: "cruise"
        })]
      })]
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputAutosuggestBlock/* InputAutosuggestBlock */.A, {
      namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
      label: {
        namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
        label: t("label:cruise.vesselBrand"),
        colorStyleKey: labelColorStyleKey
      },
      input: {
        name: fieldName,
        value: value,
        type: "text",
        placeholder: t("form.placeholders.cruise.vesselBrandPlaceholder")
      },
      error: error,
      onSelected: onSelected,
      fetchDestinationSuggest: fetchVesselBrandSuggestions,
      suggestOptions: suggestOptions,
      suggestions: suggestions,
      onClear: onClearInput,
      disableOnFocusRequest: true,
      alwaysShowSuggestions: true,
      borderColorStyleKey: borderColorStyleKey,
      fontSizeStyleKey: fontSizeStyleKey,
      suggestIconType: "cruise"
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)( true ? "" : 0,  true ? "" : 0);
var headerTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:0;left:50%;line-height:3rem;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";font-weight:bold;letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";transform:translateX(-50%);" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/form/multipleSelect/MultipleSelectTag.tsx
var MultipleSelectTag = __webpack_require__(77498);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/VesselBrandBlock.tsx


var _excluded = ["text"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var VesselBrandBlock = function VesselBrandBlock(props) {
  var defaultVesselBrands = props.defaultVesselBrands,
      suggestOptions = props.suggestOptions,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      fontSizeStyleKey = props.fontSizeStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;
  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control;

  var namesFieldName = "vessel_brand_names";
  var idsFieldName = "vessel_brand_id"; // 単数

  var destinationIdsFieldName = "origin_destination_region_ids";
  var idValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: idsFieldName
  }) || [];
  var nameValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: namesFieldName
  }) || [];
  var destinationIdValues = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: destinationIdsFieldName
  }) || [];

  var onRemoveClick = function onRemoveClick(value) {
    var targetIndex = idValues.findIndex(function (id) {
      return id === value;
    });

    if (targetIndex >= 0) {
      var newIds = idValues.filter(function (_, index) {
        return index !== targetIndex;
      });
      var newNames = nameValues.filter(function (_, index) {
        return index !== targetIndex;
      });
      setValue(idsFieldName, newIds);
      setValue(namesFieldName, newNames);
    }
  };

  var fetchVesselBrandSuggestionsAction = function fetchVesselBrandSuggestionsAction(data) {
    var text = data.text,
        rest = (0,objectWithoutProperties/* default */.Z)(data, _excluded);

    appDispatch((0,cruiseSuggestionSlice/* debouncedFetchVesselBrandSuggestions */._P)({
      params: _objectSpread(_objectSpread({
        text: text
      }, rest), {}, {
        origin_destination_region_ids: destinationIdValues
      })
    }));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: VesselBrandBlock_blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VesselBrandInputBlock, {
      fetchVesselBrandSuggestions: fetchVesselBrandSuggestionsAction,
      labelColorStyleKey: labelColorStyleKey,
      suggestOptions: suggestOptions,
      defaultVesselBrands: defaultVesselBrands,
      borderColorStyleKey: borderColorStyleKey,
      fontSizeStyleKey: fontSizeStyleKey,
      disableStopBodyScrolling: disableStopBodyScrolling
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: selectTagBlockStyle,
      children: idValues.map(function (id, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultipleSelectTag/* MultipleSelectTag */.N, {
          text: nameValues[index],
          value: id,
          onRemoveClick: onRemoveClick
        }, id);
      })
    })]
  });
};
var VesselBrandBlock_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 0;flex:1;" + ( true ? "" : 0),  true ? "" : 0);
var selectTagBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-wrap:wrap;gap:", spaceStyle/* space.atom */.D.atom, ";padding:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 94477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ StaysBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27812);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26793);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14864);
/* harmony import */ var main_javascripts_components_form_Label__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35183);
/* harmony import */ var main_javascripts_constants_FormConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36581);
/* harmony import */ var main_javascripts_constants_CruiseConstants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78022);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96749);
/* harmony import */ var _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36716);
/* harmony import */ var _styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80910);
/* harmony import */ var _styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88433);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var StaysBlock = function StaysBlock(props) {
  var _props$labelColorStyl = props.labelColorStyleKey,
      labelColorStyleKey = _props$labelColorStyl === void 0 ? "default" : _props$labelColorStyl,
      _props$borderColorSty = props.borderColorStyleKey,
      borderColorStyleKey = _props$borderColorSty === void 0 ? "none" : _props$borderColorSty,
      _props$fontSizeStyleK = props.fontSizeStyleKey,
      fontSizeStyleKey = _props$fontSizeStyleK === void 0 ? "default" : _props$fontSizeStyleK;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)(["label"]),
      t = _useTranslation.t;

  var minStaysFieldName = "min_stays";
  var maxStaysFieldName = "max_stays";

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .useFormContext */ .Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var minStaysValue = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .useWatch */ .qo)({
    control: control,
    name: minStaysFieldName
  });
  var maxStaysValue = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .useWatch */ .qo)({
    control: control,
    name: maxStaysFieldName
  });

  var isNumeric = function isNumeric(value) {
    return value !== "" && !isNaN(Number(value));
  };

  var renderMinStays = function renderMinStays() {
    var maxStaysLimit = isNumeric(maxStaysValue) ? Number(maxStaysValue) : main_javascripts_constants_CruiseConstants__WEBPACK_IMPORTED_MODULE_10__/* .MAX_CRUISE_STAYS */ .u8;
    var range = Array.from({
      length: maxStaysLimit
    }, function (_, i) {
      return i + 1;
    });
    var optionList = [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("option", {
      value: "",
      children: t("common.unspecified")
    }, "-")].concat((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(range.map(function (value) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("option", {
        value: value,
        children: value
      }, value);
    })));
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("div", {
      css: staysInputBlockStyle,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__/* .SelectBlock */ .w, {
        namespace: main_javascripts_constants_FormConstants__WEBPACK_IMPORTED_MODULE_3__/* .FormNamespaces.cruise */ .Z.cruise // label={{
        //   namespace: FormNamespaces.cruise,
        //   label: "minStays",
        //   colorStyleKey: labelColorStyleKey,
        // }}
        ,
        select: {
          name: minStaysFieldName,
          children: optionList
        },
        error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .get */ .U2)(errors, minStaysFieldName),
        borderColorStyleKey: borderColorStyleKey,
        fontSizeStyleKey: fontSizeStyleKey
      })
    });
  };

  var renderMaxStays = function renderMaxStays() {
    var minStaysLimit = isNumeric(minStaysValue) ? Number(minStaysValue) : 1;
    var range = Array.from({
      length: main_javascripts_constants_CruiseConstants__WEBPACK_IMPORTED_MODULE_10__/* .MAX_CRUISE_STAYS */ .u8 - minStaysLimit + 1
    }, function (_, i) {
      return minStaysLimit + i;
    });
    var optionList = [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("option", {
      value: "",
      children: t("common.unspecified")
    }, "-")].concat((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(range.map(function (value) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("option", {
        value: value,
        children: value
      }, value);
    })));
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("div", {
      css: staysInputBlockStyle,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__/* .SelectBlock */ .w, {
        namespace: main_javascripts_constants_FormConstants__WEBPACK_IMPORTED_MODULE_3__/* .FormNamespaces.cruise */ .Z.cruise // label={{
        //   namespace: FormNamespaces.cruise,
        //   label: "maxStays",
        //   colorStyleKey: labelColorStyleKey,
        // }}
        ,
        select: {
          name: maxStaysFieldName,
          children: optionList
        },
        error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .get */ .U2)(errors, maxStaysFieldName),
        borderColorStyleKey: borderColorStyleKey,
        fontSizeStyleKey: fontSizeStyleKey
      })
    });
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("div", {
      css: labelBlockStyle,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(main_javascripts_components_form_Label__WEBPACK_IMPORTED_MODULE_2__/* .Label */ ._, {
        namespace: main_javascripts_constants_FormConstants__WEBPACK_IMPORTED_MODULE_3__/* .FormNamespaces.cruise */ .Z.cruise,
        label: "stays",
        colorStyleKey: labelColorStyleKey
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)("div", {
      css: inputBlockStyle,
      children: [renderMinStays(), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("div", {
        css: delimiterStyle,
        children: "\u2014"
      }), renderMaxStays()]
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("padding-top:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var inputBlockStyle =  true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0;
var staysInputBlockStyle =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;
var labelBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("padding:calc(", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " - (", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .lineHeight.body1 */ .Nv.body1, " - ", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .fontSize.body */ .JB.body, ") / 2) ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " 0;margin-bottom:calc(\n    (", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " - (", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .lineHeight.body1 */ .Nv.body1, " - ", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .fontSize.body */ .JB.body, ") / 2) * -1\n  );" + ( true ? "" : 0),  true ? "" : 0);
var delimiterStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("display:flex;align-items:center;height:40px;padding:calc(", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " - (", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .lineHeight.body1 */ .Nv.body1, " - ", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .fontSize.body */ .JB.body, ") / 2) 0 0;color:", _styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";", (0,_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_7__/* .moreThanBreakpoint */ .h6)("tablet"), "{padding-left:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";padding-right:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 77498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ MultipleSelectTag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58589);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36716);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);








var MultipleSelectTag = function MultipleSelectTag(props) {
  var text = props.text,
      value = props.value,
      onRemoveClick = props.onRemoveClick,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "default" : _props$styleKey;

  var onClick = function onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    onRemoveClick(value);
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
    css: blockStyle[styleKey],
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      css: textStyle,
      children: text
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      css: removeButtonStyle[styleKey],
      onClick: onClick
    })]
  });
};
var blockBaseStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("position:relative;display:flex;align-items:center;font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontWeight.regular */ .Ue.regular, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .borderColor.primaryLightColor */ .tv.primaryLightColor, ";border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_2__/* .borderRadius.normal */ .E.normal, ";box-sizing:border-box;appearance:none;border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_2__/* .borderRadius.normal */ .E.normal, ";max-width:100%;&:focus{outline:none;}&:disabled{background-color:transparent;color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";cursor:not-allowed;opacity:1;}" + ( true ? "" : 0),  true ? "" : 0);
var blockStyle = {
  "default": /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(blockBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.body */ .JB.body, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .lineHeight.body1 */ .Nv.body1, ";padding:0 2rem 0 0;" + ( true ? "" : 0),  true ? "" : 0),
  defaultDark: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(blockBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.body */ .JB.body, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .lineHeight.body1 */ .Nv.body1, ";padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom0_5x */ .D.atom0_5x, " 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom0_5x */ .D.atom0_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom1_5x */ .D.atom1_5x, ";background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .backgroundColor.primaryLightColor */ .Cz.primaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  small: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(blockBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.caption */ .JB.caption, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .lineHeight.body2 */ .Nv.body2, ";padding:0 0 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom1_5x */ .D.atom1_5x, ";" + ( true ? "" : 0),  true ? "" : 0)
};
var textStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom0_5x */ .D.atom0_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom0_5x */ .D.atom0_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom0_5x */ .D.atom0_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var removeButtonBaseStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("position:absolute;top:50%;right:0;width:2rem;height:100%;min-height:2rem;display:flex;align-items:center;cursor:pointer;transform:translateY(-50%);&::before,&::after{content:\"\";position:absolute;top:50%;left:50%;display:block;width:1rem;height:1px;background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .textColor.disabledColor */ .zP.disabledColor, ";}&::before{transform:translate(-50%, -50%) rotate(45deg);}&::after{transform:translate(-50%, -50%) rotate(-45deg);}&:hover{&::before,&::after{background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryColor */ .z.primaryColor, ";}}" + ( true ? "" : 0),  true ? "" : 0);
var removeButtonLightStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(removeButtonBaseStyle, ";&::before,&::after{background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .backgroundColor.primaryLightColor */ .Cz.primaryLightColor, ";}&:hover{&::before,&::after{background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryColor */ .z.primaryColor, ";}}" + ( true ? "" : 0),  true ? "" : 0);
var removeButtonStyle = {
  "default": /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(removeButtonBaseStyle, ";" + ( true ? "" : 0),  true ? "" : 0),
  defaultDark: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(removeButtonLightStyle, ";" + ( true ? "" : 0),  true ? "" : 0),
  small: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(removeButtonBaseStyle, ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 78022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AM": function() { return /* binding */ MAX_NUMBER_OF_CABINS; },
/* harmony export */   "DP": function() { return /* binding */ MAX_CRUISE_DEPARTURE_DATE_RANGE_DAYS; },
/* harmony export */   "Ky": function() { return /* binding */ DEFAULT_ADULTS; },
/* harmony export */   "Ub": function() { return /* binding */ MAX_AGE_OF_CHILDREN; },
/* harmony export */   "Zh": function() { return /* binding */ MAX_CHILDREN; },
/* harmony export */   "u8": function() { return /* binding */ MAX_CRUISE_STAYS; },
/* harmony export */   "zB": function() { return /* binding */ MAX_ADULTS; }
/* harmony export */ });
var MAX_CRUISE_STAYS = 20;
var MAX_CRUISE_DEPARTURE_DATE_RANGE_DAYS = 90;
var MAX_NUMBER_OF_CABINS = 9;
var MAX_ADULTS = 10;
var DEFAULT_ADULTS = 2;
var MAX_CHILDREN = 10;
var MAX_AGE_OF_CHILDREN = 12;

/***/ })

}]);